/** @param {"backgroundColor" | "color"} attr */
const jsToScss = (attr) => attr.replace(/([A-Z])/g, "-$1").toLowerCase();

/**
 * @typedef {Object} PaletteAttributes
 * @property {string} [backgroundColor]
 * @property {string} [color]
 */

/**
 * Converts string attributes in javascript layer to class names generated by
 * utility_classes mixin.
 *
 * @param {PaletteAttributes} attrs
 */
export const toUtilityClasses = (attrs) =>
  Object.entries(attrs)
    .filter(([, v]) => v)
    .map(([attr, value]) => `${jsToScss(attr)}-${value}`)
    .join(" ");
